import { useSuspenseQuery } from '@tanstack/react-query';
import { createFileRoute } from '@tanstack/react-router';

import { ReviewView, getReviewOptions } from '@/module/Author/Review';

export const Route = createFileRoute('/_auth/author/_author/review/_review/$reviewId/_layout/')({
  component: RouteComponent,
  staticData: {
    pageTitle: { id: 'pageTitle.view' },
  },
});

function RouteComponent() {
  const { reviewId } = Route.useParams();
  const { data: review } = useSuspenseQuery(getReviewOptions(reviewId));

  return <ReviewView review={review} />;
}
